(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6694],{

/***/ 88334:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/proofer",
      function () {
        return __webpack_require__(4931);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BaseSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59370);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52375);



var trimTrailingSlash = function(slug) {
    return slug[slug.length - 1] === "/" ? slug.slice(0, slug.length - 1) : slug;
};
var BaseSeo = function(param) {
    var title = param.title, ogTitle = param.ogTitle, description = param.description, ogDescription = param.ogDescription, path = param.path, image = param.image;
    var canonical = path ? "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(trimTrailingSlash(path)) : _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    var baseTitle = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_NAME */ .px;
    var baseDescription = "Colophon is an international, award-winning type foundry based in London (UK) and Los Angeles (US). We create, publish, and distribute high-quality retail and custom typefaces for analog and digital media.";
    var seoTitle = title || baseTitle;
    var seoDescription = description || baseDescription;
    var twitter = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1 ? {
        handle: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1,
        cardType: "summary_large_image"
    } : null;
    var openGraph = {
        url: canonical,
        title: ogTitle || seoTitle,
        description: ogDescription || seoDescription,
        images: [
            {
                url: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(image ? image : "/img/og.png"),
                alt: "Colophon Foundry"
            }
        ],
        site_name: "Colophon Foundry"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seoTitle,
        description: seoDescription,
        canonical: canonical,
        twitter: twitter,
        openGraph: openGraph
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseSeo);


/***/ }),

/***/ 4931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ proofer; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./storyblok/index.ts + 2 modules
var storyblok = __webpack_require__(47659);
// EXTERNAL MODULE: ./components/index.ts + 27 modules
var components = __webpack_require__(94842);
// EXTERNAL MODULE: ./components/global/Footer/index.ts + 4 modules
var Footer = __webpack_require__(6695);
// EXTERNAL MODULE: ./components/global/Header/index.tsx + 7 modules
var Header = __webpack_require__(50794);
// EXTERNAL MODULE: ./components/seo/BaseSeo.tsx
var BaseSeo = __webpack_require__(57758);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(6666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./components/global/Pagination.tsx
var Pagination = __webpack_require__(1776);
// EXTERNAL MODULE: ./components/providers/RegionsProvider.tsx + 10 modules
var RegionsProvider = __webpack_require__(60239);
// EXTERNAL MODULE: ./lib/fonts/s3FontPath.ts
var s3FontPath = __webpack_require__(57189);
// EXTERNAL MODULE: ./lib/paths.ts + 1 modules
var lib_paths = __webpack_require__(47475);
// EXTERNAL MODULE: ./lib/productHelpers.tsx
var productHelpers = __webpack_require__(11603);
// EXTERNAL MODULE: ./saleor/api.tsx + 4 modules
var api = __webpack_require__(67062);
// EXTERNAL MODULE: ./components/tools/Proofer/Proofer.module.scss
var Proofer_module = __webpack_require__(97480);
var Proofer_module_default = /*#__PURE__*/__webpack_require__.n(Proofer_module);
// EXTERNAL MODULE: ./components/global/FontLoader/index.tsx
var FontLoader = __webpack_require__(53409);
// EXTERNAL MODULE: ./components/tools/Proofer/ProoferCard.module.scss
var ProoferCard_module = __webpack_require__(13053);
var ProoferCard_module_default = /*#__PURE__*/__webpack_require__.n(ProoferCard_module);
;// CONCATENATED MODULE: ./components/tools/Proofer/ProoferCard.tsx





var ProoferCard = function(param) {
    var fontName = param.fontName, s3Path = param.s3Path, setSelectedFontFamily = param.setSelectedFontFamily, children = param.children;
    var onSelectFontFamily = function(e) {
        return setSelectedFontFamily(e.currentTarget.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoader/* default */.Z, {
                fullPath: !(s3Path === null || s3Path === void 0 ? void 0 : s3Path.includes("https://")),
                fontName: fontName,
                s3Path: s3Path
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: (ProoferCard_module_default()).radio,
                type: "radio",
                id: fontName,
                name: "fontFamily",
                value: fontName,
                onChange: onSelectFontFamily
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: fontName,
                className: (0,clsx_m/* default */.Z)((ProoferCard_module_default()).card),
                children: children
            })
        ]
    }, fontName);
};
/* harmony default export */ var Proofer_ProoferCard = (ProoferCard);

;// CONCATENATED MODULE: ./components/tools/Proofer/Proofer.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















var ProoferShell = function(param) {
    var totalCount = param.totalCount, fontFamilies = param.fontFamilies;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: _toConsumableArray(Array(totalCount - (fontFamilies === null || fontFamilies === void 0 ? void 0 : fontFamilies.length))).map(function(e, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((Proofer_module_default()).Proofer__gridItem, (Proofer_module_default())["Proofer__gridItem--loading"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            }, i);
        })
    });
};
var Proofer = function(param) {
    var serverFontFamilies = param.serverFontFamilies, categoryId = param.categoryId;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var query = (0,RegionsProvider/* useRegions */.eH)().query;
    var paths = (0,lib_paths/* usePaths */._)();
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(null), selectedFontFamily = ref6[0], setSelectedFontFamily = ref6[1];
    var DEFAULT_FILTERS = {
        categories: [
            categoryId
        ],
        search: ""
    };
    var ref7 = (0,react.useState)(DEFAULT_FILTERS), filters = ref7[0], setFilters = ref7[1];
    var ref8 = (0,react.useState)(), familiesData = ref8[0], setFamiliesData = ref8[1];
    var familiesRenderData = (0,react.useCallback)(function() {
        return familiesData || serverFontFamilies;
    }, [
        familiesData,
        serverFontFamilies
    ]);
    var ref9 = _slicedToArray((0,api/* useCustomiserCollectionLazyQuery */.pXK)({
        fetchPolicy: "cache-and-network",
        onCompleted: function(result) {
            setFamiliesData({
                products: result === null || result === void 0 ? void 0 : result.products
            });
        }
    }), 2), getProducts = ref9[0], loading = ref9[1].loading;
    var onLoadMore = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(cursor) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!loading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return getProducts({
                            variables: _objectSpread({
                                filter: filters,
                                first: 10,
                                after: cursor
                            }, query)
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onLoadMore(cursor) {
            return _ref.apply(this, arguments);
        };
    }();
    var dataFontFamilies = ((ref = familiesRenderData()) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.edges.map(function(edge) {
        return edge.node;
    })) || [];
    var pageInfo = (ref2 = familiesRenderData()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.pageInfo;
    var totalCount = ((ref4 = familiesRenderData()) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.products) === null || ref5 === void 0 ? void 0 : ref5.totalCount) || 0;
    (0,react.useMemo)(function() {
        getProducts({
            variables: _objectSpread({
                filter: filters,
                first: 100,
                after: null
            }, query)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getProducts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
        className: (Proofer_module_default()).CustomiserResult__grid,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
            sm: 12,
            md: 12,
            lg: 12,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (Proofer_module_default()).Proofer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Proofer_module_default()).Proofer__Header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (Proofer_module_default()).Proofer__Heading,
                            children: "Select a Font Family to Test"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Proofer_module_default()).Proofer__main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Proofer_module_default()).Proofer__wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Proofer_module_default()).Proofer__grid,
                                    role: "radiogroup",
                                    "aria-label": "Font families",
                                    children: [
                                        (dataFontFamilies === null || dataFontFamilies === void 0 ? void 0 : dataFontFamilies.length) > 0 ? dataFontFamilies.map(function(fontFamily) {
                                            var name = fontFamily.name, slug = fontFamily.slug, variants = fontFamily.variants, attributes = fontFamily.attributes, metadata = fontFamily.metadata;
                                            var fontDisplayName = (0,productHelpers/* getFontDisplayName */.Ow)({
                                                name: name,
                                                metadata: metadata
                                            });
                                            var fontSizeAdjust = (0,productHelpers/* getProductFontSizeAdjust */.tM)(fontFamily);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Proofer_module_default()).Proofer__gridItem,
                                                style: _objectSpread({}, fontSizeAdjust && {
                                                    "--font-size-adjust": fontSizeAdjust
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Proofer_ProoferCard, {
                                                    fontName: slug,
                                                    s3Path: (0,s3FontPath/* generateS3PathFromVariants */.q0)(slug, variants, attributes),
                                                    setSelectedFontFamily: setSelectedFontFamily,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Proofer_module_default()).fontName,
                                                        style: {
                                                            fontFamily: slug
                                                        },
                                                        children: fontDisplayName.replace(/<br\s*\/?>/gi, "\n")
                                                    })
                                                })
                                            }, name);
                                        }) : "No results",
                                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProoferShell, {
                                            totalCount: totalCount,
                                            fontFamilies: dataFontFamilies
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                                onLoadMore: onLoadMore,
                                pageInfo: pageInfo,
                                loadOnScroll: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)([
                            (Proofer_module_default()).Proofer__Controls
                        ]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Proofer_module_default()).Proofer__ControlsInner,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Proofer_module_default()).Proofer__ControlsButtonContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "button",
                                        className: (0,clsx_m/* default */.Z)((Proofer_module_default()).Proofer__Button),
                                        variant: "primary",
                                        ariaLabel: "Take me to proofer",
                                        size: "xl",
                                        callBack: function() {
                                            return router.push(paths.typefaces._slug(selectedFontFamily).proofer._fontStyle().$url());
                                        },
                                        disabled: !selectedFontFamily,
                                        children: "Take me to proofer \u2192"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Proofer_Proofer = (Proofer);

// EXTERNAL MODULE: ./lib/storyblok/storyblokNavLinks.ts
var storyblokNavLinks = __webpack_require__(83176);
;// CONCATENATED MODULE: ./pages/tools/proofer.tsx








var ToolsPage = function(param) {
    var story = param.story, preview = param.preview, resolve_relations = param.resolve_relations, products = param.products, categoryId = param.categoryId;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var sbStory = preview ? (0,storyblok/* useStoryblok */.P)(story, preview, resolve_relations) : story;
    var globalLinks = (0,storyblokNavLinks/* getStoryBlokNavLinks */.G)(story);
    var _content = sbStory.content, _SEO = _content.SEO, SEO = _SEO === void 0 ? {} : _SEO, name = sbStory.name, full_slug = sbStory.full_slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSeo/* default */.Z, {
                title: SEO === null || SEO === void 0 ? void 0 : SEO.title,
                description: SEO === null || SEO === void 0 ? void 0 : SEO.description,
                ogDescription: SEO === null || SEO === void 0 ? void 0 : SEO.og_description,
                ogTitle: SEO === null || SEO === void 0 ? void 0 : SEO.og_title,
                image: SEO === null || SEO === void 0 ? void 0 : SEO.og_image,
                path: full_slug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                navigation: globalLinks,
                headerTheme: "header-white",
                pageName: name,
                hasBorder: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main",
                className: "page-padding-top page-theme-charcoal th-white-charcoal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Proofer_Proofer, {
                    serverFontFamilies: {
                        products: products
                    },
                    categoryId: categoryId
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.ZP, {
                theme: "charcoal",
                navigation: globalLinks.footerLinks
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var proofer = (ToolsPage);
ToolsPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Layout */.Ar, {
        children: page
    });
};


/***/ }),

/***/ 47659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Storyblok; },
  "P": function() { return /* reexport */ useStoryblok; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./storyblok/hooks/useStoryblok.ts


function useStoryblok(originalStory, preview) {
    var resolve_relations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var initEventListeners = // adds the events for updating the visual editor
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#initializing-the-storyblok-js-bridge
    function initEventListeners() {
        var StoryblokBridge = window.StoryblokBridge;
        if (typeof StoryblokBridge !== "undefined") {
            // initialize the bridge with your token
            var storyblokInstance = new StoryblokBridge({
                resolveRelations: resolve_relations
            });
            // reload on Next.js page on save or publish event in the Visual Editor
            storyblokInstance.on([
                "change",
                "published"
            ], function() {
                return location.reload();
            });
            // live update the story on input events
            storyblokInstance.on("input", function(event) {
                // check if the ids of the event and the passed story match
                if (story && event.story.content._uid === story.content._uid) {
                    // change the story content through the setStory function
                    setStory(event.story);
                }
            });
            storyblokInstance.on("enterEditmode", function(event) {
                // loading the draft version on initial enter of editor
                Storyblok.get("cdn/stories/".concat(event.storyId), {
                    resolve_relations: resolve_relations,
                    version: "draft"
                }).then(function(param) {
                    var data = param.data;
                    if (data.story) {
                        setStory(data.story);
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            });
        }
    };
    var addBridge = // appends the bridge script tag to our document
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#installing-the-storyblok-js-bridge
    function addBridge(callback) {
        // check if the script is already present
        var existingScript = document.getElementById("storyblokBridge");
        if (!existingScript) {
            var script = document.createElement("script");
            script.src = "//app.storyblok.com/f/storyblok-v2-latest.js";
            script.id = "storyblokBridge";
            document.body.appendChild(script);
            script.onload = function() {
                // once the scrip is loaded, init the event listeners
                callback();
            };
        } else {
            callback();
        }
    };
    var ref = (0,react.useState)(originalStory), story = ref[0], setStory = ref[1];
    (0,react.useEffect)(function() {
        // only load inside preview mode
        if (preview) {
            // first load the bridge, then initialize the event listeners
            addBridge(initEventListeners);
        }
    }, [
        originalStory,
        preview,
        setStory
    ]); // runs the effect only once & defines effect dependencies
    return story;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/storyblok-js-client@4.5.6_axios@0.21.4/node_modules/storyblok-js-client/dist/index.es.js
var index_es = __webpack_require__(78578);
;// CONCATENATED MODULE: ./storyblok/lib/storyblok.js

var STORYBOOK_API_KEY = "WygMRPInxMCOSMUw1Vt4TAtt";
var Storyblok = new index_es/* default */.Z({
    accessToken: STORYBOOK_API_KEY,
    cache: {
        clear: "auto",
        type: "memory"
    }
});

;// CONCATENATED MODULE: ./storyblok/index.ts




/***/ }),

/***/ 97480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Proofer":"Proofer_Proofer__n8mNl","Proofer__Header":"Proofer_Proofer__Header__E1U4Z","Proofer__Heading":"Proofer_Proofer__Heading__JCgy5","Proofer__main":"Proofer_Proofer__main__aYjmg","Proofer__wrapper":"Proofer_Proofer__wrapper__IjXAe","Proofer__grid":"Proofer_Proofer__grid__Nm8eZ","Proofer__gridItem":"Proofer_Proofer__gridItem__5MWZK","Proofer__gridItem--loading":"Proofer_Proofer__gridItem--loading__X3EsG","shine":"Proofer_shine__yiaaF","Proofer__Controls":"Proofer_Proofer__Controls__Fgt8f","Proofer__ControlsInner":"Proofer_Proofer__ControlsInner__pYC0t","Proofer__Button":"Proofer_Proofer__Button__DFs7t","fontName":"Proofer_fontName__3StwV"};

/***/ }),

/***/ 13053:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"ProoferCard_radio__772JJ","card":"ProoferCard_card__4qNWd"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7099,9370,8578,7972,9774,2888,179], function() { return __webpack_exec__(88334); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);